import { columnStore } from '@/fsd/entities/table';
import { makeAutoObservable, runInAction } from 'mobx';
import { MUTUAL_SETTLEMENTS_LIST_DEFAULT_COLUMNS } from '../../lib/consts/mutualSettlementsListDefaultColumns';
import { MUTUAL_SETTLEMENTS_TABLE_KEY } from '../consts/mutualSettlementsTableKey';
import { IDateRange } from '@/fsd/shared/ui/date-picker/model/types/IDateRange';

class MutualSettlementsStore {
  instanceId = Math.random();
  columns = columnStore.getColumns(
    MUTUAL_SETTLEMENTS_TABLE_KEY,
    MUTUAL_SETTLEMENTS_LIST_DEFAULT_COLUMNS
  );
  data: {
    selectedId?: number;
  } = {
    selectedId: undefined,
  };

  isCreateModalOpen = false;
  createForm: {
    counterpartyId: number | undefined;
    organisationId: number | undefined;
    dateRange: IDateRange;
  } = {
    counterpartyId: undefined,
    organisationId: undefined,
    dateRange: { startDate: undefined, endDate: undefined },
  };

  constructor() {
    makeAutoObservable(this);
    columnStore.setColumns(
      MUTUAL_SETTLEMENTS_TABLE_KEY,
      MUTUAL_SETTLEMENTS_LIST_DEFAULT_COLUMNS
    );
  }

  toggleColumn = (columnId: string) => {
    columnStore.toggleColumn(MUTUAL_SETTLEMENTS_TABLE_KEY, columnId);
    this.columns = columnStore.getColumns(
      MUTUAL_SETTLEMENTS_TABLE_KEY,
      MUTUAL_SETTLEMENTS_LIST_DEFAULT_COLUMNS
    );
  };

  toggleAllColumns = (isVisible: boolean) => {
    columnStore.toggleAll(MUTUAL_SETTLEMENTS_TABLE_KEY, isVisible);
    this.columns = columnStore.getColumns(
      MUTUAL_SETTLEMENTS_TABLE_KEY,
      MUTUAL_SETTLEMENTS_LIST_DEFAULT_COLUMNS
    );
  };

  checkIfColumnIsVisible = (columnId: string) => {
    return columnStore.checkIfColumnIsVisible(
      MUTUAL_SETTLEMENTS_TABLE_KEY,
      columnId
    );
  };

  setSelectedId = (id?: number) => {
    runInAction(() => {
      this.data.selectedId = id;
    });
  };

  setIsCreateModalOpen = (isOpen: boolean) => {
    this.isCreateModalOpen = isOpen;
  };

  setCounterpartyId = (id?: number) => {
    runInAction(() => {
      this.createForm.counterpartyId = id;
    });
  };
  setOrganisationId = (id?: number) => {
    runInAction(() => {
      this.createForm.organisationId = id;
    });
  };
  setDateRange = (range: IDateRange) => {
    runInAction(() => {
      this.createForm.dateRange = range;
    });
  };
  reset = () => {
    runInAction(() => {
      this.createForm.counterpartyId = undefined;
      this.createForm.organisationId = undefined;
      this.createForm.dateRange = { startDate: undefined, endDate: undefined };
    });
  };
}

export const mutualSettlementsStore = new MutualSettlementsStore();
